export default {
	name:'confirm-dialog',
	data () {
		return {
			zendeskInfo:null,
			msg:null,
			data:null,
			loading:false
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			
			var triggerInstance;
			if(this.$route.query.hdTicketId && this.$route.query.cacheReset)
				triggerInstance=`confirm-dialog_zd${this.$route.query.hdTicketId}_cacheReset`
			else if(this.$route.query.hdTicketId && this.$route.query.workItemId)
				triggerInstance=`confirm-dialog_zd${this.$route.query.hdTicketId}_wd${this.$route.query.workItemId}`
			else if(this.$route.query.hdTicketId && this.$route.query.issueId)
				triggerInstance=`confirm-dialog_zd${this.$route.query.hdTicketId}_wd${this.$route.query.issueId}`
			else if(this.$route.query.hdTicketId && this.$route.query.taskId)
				triggerInstance=`confirm-dialog_zd${this.$route.query.hdTicketId}_wd${this.$route.query.taskId}`
			else if(this.$route.query.fileId)
				triggerInstance=`confirm-dialog_file${this.$route.query.fileId}`

			modalClient.on(triggerInstance, (data) => {
				parentClient = modalClient.instance(data.parentClientGuid)
				_self.zendeskInfo=data;
				_self.msg=data.msg;
			});
		},
		confirmButtonClick(){
			let _self=this;
			let response={type:'confirmed',Success:true};
			_self.sendDataToParent(response);
		},
		closeDialog(){
			let _self=this;
			//modalClient.invoke('destroy');
			let response={Success:false};
			_self.sendDataToParent(response);
		},
		sendDataToParent(data){
			this.loading=true;	
			var triggerInstance;
			if(this.$route.query.hdTicketId && this.$route.query.cacheReset)
				triggerInstance=`remove-confirm-dialog_zd${this.$route.query.hdTicketId}_cacheReset`
			else if(this.$route.query.hdTicketId && this.$route.query.workItemId)
				triggerInstance=`remove-confirm-dialog_zd${this.$route.query.hdTicketId}_wd${this.$route.query.workItemId}`
			else if(this.$route.query.hdTicketId && this.$route.query.issueId)
				triggerInstance=`remove-confirm-dialog_zd${this.$route.query.hdTicketId}_wd${this.$route.query.issueId}`
			else if(this.$route.query.hdTicketId && this.$route.query.taskId)
				triggerInstance=`remove-confirm-dialog_zd${this.$route.query.hdTicketId}_wd${this.$route.query.taskId}`
			else if(this.$route.query.fileId)
				triggerInstance=`remove-confirm-dialog_file${this.$route.query.fileId}`
				
			parentClient.trigger(triggerInstance, data)
      		modalClient.invoke('destroy');

		}
	}
}

